module.exports = __webpack_public_path__ + "static/Especialistas_Corveador-29d0d1e2e299ca464e62c5a9909c2508.jpg";